export default __webpack_public_path__ + "static/media/product_dummy_1.6f163dd3.jpg";